export const DRAFT_GET_ALL = "DRAFT_GET_ALL";
